import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, TextField, Typography, Container } from '@mui/material';

const RegisterPage = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');

    const handleRegister = async(e) => {
        e.preventDefault();

        if(!email || !password || !confirmPassword || name) {
            setError('All fields are required.');
            return;
        }
        if (password !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }
        try {
            const response = await fetch('http://localhost:8080/api/users/register', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({email, password, name })
            });

            if(response.ok){
                alert('Registration successful. Please log in.');
                navigate('/login');
            } else {
                const errorData = await response.json();
            }
        } catch (error) {
            console.error('Error during registration:', error);
            setError('An unexpected error occurred.');
        }
        return (
            <Container style={{ padding: '20px', textAlign: 'center' }}>
                <Typography variant="h4" gutterBottom>Register</Typography>
                <form onSubmit={handleRegister}>
                    <TextField label="Name" value={name} onChange={(e) => setName(e.target.value)} required /><br/>
                    <TextField label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required /><br/>
                    <TextField label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required /><br/>
                    <TextField label="Confirm Password" type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required /><br/>
                    <Button type="submit">Register</Button>
                </form>
                {error && <p style={{ color: 'red' }}>{error}</p>}
            </Container>
        );
    };
};

export default RegisterPage;